import React, { useEffect, useState } from "react";
import { RHFTextField, Section, RHFSelect } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import { AURA_QUESTION } from "../../config/const/enums";
import { useWatch } from "react-hook-form";

function AuraUnitizedQuestion({
  mappedContent,
  isNumberType,
  setUnitizedDropdownOption,
  control,
  defaultValue,
  setAnsRemapDropDwnNumericCount,
}) {
  const unitizedOptionValue = useWatch({
    control,
    name: "unitizedOption",
    defaultValue: "",
  });

  useEffect(() => {
    if (unitizedOptionValue) {
      if (defaultValue.unitizedOption !== unitizedOptionValue) {
        setAnsRemapDropDwnNumericCount(
          (prevAnsRemapDropDwnNumericCount) =>
            prevAnsRemapDropDwnNumericCount + 1
        );
      }
      setUnitizedDropdownOption(unitizedOptionValue);
    }
  }, [unitizedOptionValue]);

  return (
    <Section md={7}>
      {mappedContent.context && (
        <Section mb={3}>
          <Typography
            mb={4}
            sx={{
              width: "fit-content !important",
            }}
            variant="label-large-bold"
          >
            {mappedContent.context}
          </Typography>
        </Section>
      )}
      {mappedContent.statement && (
        <Typography
          sx={{
            marginBottom: 5 / 2,
            display: "flex",
          }}
          variant="label-large-bold"
        >
          {mappedContent.statement}
        </Typography>
      )}
      <Typography
        sx={{
          marginBottom: 4,
        }}
        variant="label-large-bold"
        dangerouslySetInnerHTML={{ __html: mappedContent.richText }}
      ></Typography>
      {mappedContent.isDropdownNumeric ? (
        <Section sx={{ display: "flex" }}>
          <Section md={6}>
            <RHFTextField
              defaultValue={defaultValue.unitizedValue}
              name="unitizedValue"
              className="subvariant-text-input"
              variant="standard"
              label="How many times"
              sx={{ textTransform: "uppercase" }}
              type="number"
              showTooltip={mappedContent.richHelpText ? true : false}
              tooltipText={mappedContent.richHelpText}
            />
          </Section>
          <Section md={6} sx={{ marginLeft: 3, marginTop: "11px" }}>
            <RHFSelect
              defaultValue={defaultValue.unitizedOption}
              name="unitizedOption"
              label="How often"
              variant="standard"
              items={mappedContent.availableUnitDropdown}
            />
          </Section>
        </Section>
      ) : (
        <RHFTextField
          name={AURA_QUESTION.AURA_QUESTION_NAME}
          className="subvariant-text-input"
          variant="standard"
          label={mappedContent.labelText}
          sx={{ textTransform: "uppercase" }}
          type={isNumberType ? "number" : "text"}
          showTooltip={mappedContent.richHelpText ? true : false}
          tooltipText={mappedContent.richHelpText}
        />
      )}
    </Section>
  );
}

export default AuraUnitizedQuestion;
